import styles from "./SearchDropdown.module.scss";

const SearchDropdownBtn = ({ setShowBtn }) => {
  return (
    <button
      className={styles.search_dropdown_btn}
      onClick={() => setShowBtn(false)}
      type="button"
    >
      <img src="/img/plus.svg" alt="plus" />
    </button>
  );
};

export default SearchDropdownBtn;
